import { Component, OnInit, signal, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CapturumButtonModule } from '@capturum/ui/button';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-simple-repeat-type',
  standalone: true,
  imports: [FormlyModule, FormsModule, ReactiveFormsModule, CapturumButtonModule],
  templateUrl: './formly-simple-repeat-type.component.html',
  styleUrl: './formly-simple-repeat-type.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FormlySimpleRepeatTypeComponent extends FieldArrayType implements OnInit {
  containerStyles = signal<{ [key: string]: any }>({});

  ngOnInit(): void {
    if (!this.field.model?.length && !this.props.noAddByDefault) {
      this.add();
    }

    if (this.props?.gridView && this.props?.cols) {
      this.containerStyles.set({
        '--cols': this.props.cols,
      });
    }
  }

  override add(): void {
    super.add();

    if (this.props.onAdd && typeof this.props.onAdd === 'function') {
      // Call the onAdd function
      this.props.onAdd(this.field, this.formControl);
    }
  }

  override remove(index: number): void {
    if (this.props.onRemove && typeof this.props.onRemove === 'function') {
      // Call the onRemove function
      this.props.onRemove(this.field, this.formControl, index);
    }

    super.remove(index);
  }
}
